export default "__VITE_ASSET__SdWy41HZ__"